import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Typography } from '@material-ui/core';
import LegalDatasets from 'pages/LegalPerson/RiskDatasets/datasets';
import NaturalDatasets from 'pages/NaturalPerson/RiskDatasets/datasets';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { uniqBy } from 'lodash';

const KYCComponent = ({ isEditing, setLoading, involvedPersons, taker }) => {
	
	const naturalPersons = uniqBy([
		...involvedPersons?.filter(i => i.person?.discriminator === 'NaturalPerson'),
		taker && taker.ownerDiscriminator == "NaturalPerson" ? { personId: taker.ownerId, name: taker.ownerDisplay } : undefined]
		.filter(x => x !== undefined),
	(i) => i.personId);

	const legalPersons = uniqBy([
		...involvedPersons?.filter(i => i.person?.discriminator === 'LegalPerson'),
		taker && taker.ownerDiscriminator == "LegalPerson" ? { personId: taker?.ownerId, name: taker?.ownerDisplay } : undefined].filter(x => x !== undefined),
	(i) => i.personId);	
	return (
		<>
			{!isEditing() && <Box p={3}>
				<Typography variant="h6" gutterBottom>
					Salve o registro para ver os dados
				</Typography>
			</Box>}
			{isEditing() && <>
				{legalPersons.length > 0 && <>
					<Typography variant="h6">
						Pessoas Jurídicas
					</Typography>
					{legalPersons?.map((person) => (
						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>{person?.name || person?.person.name}</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<Container>
									<Box>
										<LegalDatasets setLoading={setLoading} legalPersonId={person?.personId} />
									</Box>
								</Container>
							</AccordionDetails>
						</Accordion>
					))}
					<br />
				</>}
				{naturalPersons.length > 0 && <Typography variant="h6">
					Pessoas Físicas
				</Typography>}
				{naturalPersons?.map(person => (
					<Accordion>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<Typography>{person?.name || person.person?.name}</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Container>
								<Box>
									<NaturalDatasets setLoading={setLoading} naturalPersonId={person?.personId} />
								</Box>
							</Container>
						</AccordionDetails>
					</Accordion>
				))}
			</>}
		</>
	);
};

export default KYCComponent;